"use client";

import { useWebchatStore } from "../store";
import { cn } from "@deputy-ai/common";
import { Badge } from "@deputy-ai/ui/badge/Badge";

export function UnreadMessageBadge({ className }: { className?: string }) {
  const {
    use: { unreadMessageCount },
  } = useWebchatStore();
  if (unreadMessageCount === 0) {
    return null;
  }
  return (
    <Badge
      className={cn(
        "h-6 min-w-6 items-center justify-center rounded-full px-1 font-mono tabular-nums",
        className
      )}
      variant="destructive"
    >
      {unreadMessageCount < 100 ? unreadMessageCount : "99+"}
    </Badge>
  );
}
